import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'site-modules/shared/components/link/link';
import React from 'react';

import './clickable-card-link.scss';

export const ClickableCardLink = ({
  children,
  className = undefined,
  linkComponent: LinkComponent = Link,
  ...rest
}) => {
  return (
    <LinkComponent className={classNames('clickable-card-link', className)} {...rest}>
      {children}
    </LinkComponent>
  );
};

ClickableCardLink.propTypes = {
  linkComponent: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
